import { AppDispatch } from "@lxp-app/store/store";
import { QuestionPreviewSliceActions } from "../slice/questionPreviewSlice";

interface payloadType {
  id: string;
  data: any;
}

export const QuestionPreviewMapping = (
  dispatch: AppDispatch,
  payload: payloadType,
  isEditingQuestion: boolean = false,
  isUploadConfig: boolean = false
) => {
  if (!payload?.id) return;

  // making all the keys to lower case
  function keysToLowerCase<T extends Record<string, any>>(obj: T) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [key.toLowerCase(), value])
    );
  }
  const dataObject = keysToLowerCase(payload.data);

  const data = { [payload?.id]: dataObject };

  if (isEditingQuestion) {
    dispatch(QuestionPreviewSliceActions.updateQuestionPreviewData(data));
    return;
  }

  // setting the data in mapping array and setting the current selected id as well in slice
  dispatch(QuestionPreviewSliceActions.setIdDataMapping(data));
};
